// --- React
import React from 'react';
// --- Styles
import './styles.scss';
// --- UI Components
import { Col } from 'antd';

/**
 * InputLabel component that displays a label and its associated content.
 *
 * @param {Object} props - Component props.
 * @param {string} props.label - The label text to be displayed.
 * @param {React.ReactNode} props.children - The child components or elements inside the label container.
 * @param {Object} props.colProps - Props to customize the column layout.
 * @param {boolean} props.required - Whether the field is required.
 * @param {string} props.error - Error message to display.
 * @returns {JSX.Element} The rendered InputLabel component.
 */
export function InputLabel({ label, children, colProps, required, error }) {
    return (
        <Col {...colProps} className="InputLabel">
            <h5>
                {label}
                {required && <span style={{ color: 'red', marginLeft: 4 }}>*</span>}
            </h5>
            {children}
            {error && (
                <div className="InputLabel-error" style={{ color: 'red', marginTop: 4 }}>
                    {error}
                </div>
            )}
        </Col>
    );
}
